import * as RD from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from './cn.js';

export const Dialog = RD.Root;
export const DialogTrigger = RD.Trigger;
export function DialogContent({
  className,
  title,
  description,
  children,
  wide,
}: {
  className?: string;
  title: string;
  description?: string;
  children: React.ReactNode;
  wide?: boolean;
}) {
  return (
    <RD.Portal>
      <RD.Overlay className="fixed inset-0 z-40 bg-navy-900/40 backdrop-blur-[1px] data-[state=open]:animate-in data-[state=open]:fade-in" />
      <RD.Content
        className={cn(
          'fixed left-1/2 top-1/2 z-50 w-full -translate-x-1/2 -translate-y-1/2 rounded-lg border bg-white p-0 shadow-xl focus:outline-none',
          wide ? 'max-w-3xl' : 'max-w-lg',
          className,
        )}
      >
        <div className="flex items-start justify-between border-b px-5 py-4">
          <div>
            <RD.Title className="text-base font-semibold text-grey-900">{title}</RD.Title>
            {description && (
              <RD.Description className="mt-0.5 text-xs text-grey-500">
                {description}
              </RD.Description>
            )}
          </div>
          <RD.Close
            className="rounded p-1 text-grey-500 hover:bg-grey-100 hover:text-grey-900"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </RD.Close>
        </div>
        <div className="px-5 py-4">{children}</div>
      </RD.Content>
    </RD.Portal>
  );
}
